import { useTheme } from 'styled-components';
import { breakPoints } from '@ovpn-ui/styles';
import { useMediaQuery } from '@ovpn-ui/utils';
export default function useDimensions() {
  var _theme$mobileBreakpoi, _theme$tabletBreakpoi;
  const theme = useTheme();
  const isMobile = useMediaQuery(`(max-width:${(_theme$mobileBreakpoi = theme == null ? void 0 : theme.mobileBreakpoint) != null ? _theme$mobileBreakpoi : breakPoints.XS}px)`);
  const isTablet = useMediaQuery(`(max-width:${(_theme$tabletBreakpoi = theme == null ? void 0 : theme.tabletBreakpoint) != null ? _theme$tabletBreakpoi : breakPoints.SM}px)`);
  return {
    isMobile,
    isTablet
  };
}